import { render } from "./App.vue?vue&type=template&id=1a44edff"
const script = {}
script.render = render

export default script